<template>
  <div>
    <button
      @click="$emit('pay')"
      class="checkout-button"
      :class="{ disabled: disable }"
    >
      <span>{{ $t("payment.pay") }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#000"
        width="30px"
        height="30px"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
        />
      </svg>
    </button>

    <!-- REDSYS REDIRECTION FORM -->
    <form :action="form.url" v-if="form" method="POST" ref="form">
      <input
        type="hidden"
        name="Ds_MerchantParameters"
        :value="form.body.Ds_MerchantParameters"
      />
      <input
        type="hidden"
        name="Ds_SignatureVersion"
        :value="form.body.Ds_SignatureVersion"
      />
      <input
        type="hidden"
        name="Ds_Signature"
        :value="form.body.Ds_Signature"
      />
    </form>
    <!-- END REDSYS REDIRECTION FORM -->
  </div>
</template>

<script>
const {
  Redsys,
  SANDBOX_URLS,
  PRODUCTION_URLS,
  TRANSACTION_TYPES,
  randomTransactionId
} = require("redsys-easy");
import paymentsMixin from "@/mixins/payment/paymentsMixin";

const redsys = new Redsys({
  secretKey: process.env.VUE_APP_REDSYS_SECRET_KEY,
  urls:
    process.env.VUE_APP_REDSYS_SANDBOX === "true"
      ? SANDBOX_URLS
      : PRODUCTION_URLS // Also PRODUCTION_URLS
});

export default {
  name: "RedsysRedirectionButton",
  props: ["amount", "selectedCard", "disable"],
  mixins: [paymentsMixin],
  data() {
    return {
      form: null
    };
  },
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    totalAmount() {
      const { cart } = this.$store.state;
      return cart.reduce((acc, item) => acc + item.quantity * item.price, 0);
    }
  },
  methods: {
    async pay() {
      const orderId = randomTransactionId();
      try {
        let paymentId = await this.initPayment({
          orders: this.cart,
          paymentMethod: "redsys",
          amount: this.totalAmount,
          orderAmount: this.totalAmount,
          paymentType: "product",
          externalPaymentId: orderId
        });
        localStorage.setItem("lastLand", "checkout");

        const obj = {
          amount: parseInt(this.amount * 100),
          currency: "EUR",
          order: orderId,
          merchantName: process.env.VUE_APP_REDSYS_MERCHANT_NAME,
          merchantCode: process.env.VUE_APP_REDSYS_MERCHANT_CODE,
          terminal: "1",
          identifier: this.selectedCard?.identifier || "REQUIRED",
          transactionType: TRANSACTION_TYPES.AUTHORIZATION, // '0'
          merchantURL: `https://${process.env.VUE_APP_REGION}-${process.env.VUE_APP_PROJECT_ID}.cloudfunctions.net/paymentSuccess?paymentId=${paymentId}`,
          successURL:
            `${process.env.VUE_APP_BASE_URL}/success-redsys?redirect=true&p_id=` +
            paymentId,
          errorURL: `${process.env.VUE_APP_BASE_URL}`
        };

        const form = redsys.redirectPetition(obj);
        console.log(
          JSON.stringify(
            JSON.parse(atob(form.body.Ds_MerchantParameters)),
            null,
            2
          )
        );
        console.log(JSON.stringify(form, null, 2));
        this.form = form;
        setTimeout(() => {
          this.$refs.form.submit();
        }, 1000);
      } catch (error) {
        this.setlogError(
          "redsys-redirection",
          "Obtained error message",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style></style>
